import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';

import { LogincacheService } from '../../../graphqlserver/logincache.service';
import {User} from '../../../modules/principal/models/usermodel';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  public iconSidebar;
  public menuItems: Menu[];
  public url: any;
  public fileurl: any;
  public permiso:boolean;

  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;

  public perfil:User;
  public _roles:any;
  public _user:boolean=false;
  public _admin:boolean=false;
  public _kardex:boolean=false;
  public _personal:boolean=false;
  public _boletas:boolean=false;
  public _vacacion:boolean=false;
  public _refrigerio:boolean=false;

  public _remuneracion:boolean=false;
  public _aportes:boolean=false;
  public _salarios:boolean=false;
  public _almacenes:boolean=false;
  public _pedidos:boolean=false;
  public _datosuser:boolean=false;
  public _repalmacen:boolean=false;
  public _cas:boolean=false;


  constructor(private router: Router, public navServices: NavService,private usercache:LogincacheService,
    public layout: LayoutService) {

    this.perfil=this.usercache.getUserLoggedIn();

    this._roles=this.perfil.permisos;
    this._roles.forEach(element => {
      if(element.label=="Usuario")
        this._user=true;
      if(element.label=="Kardex")
        this._kardex=true;
      if(element.label=="Personal")
        this._personal=true;
      if(element.label=="Administrador")
        this._admin=true;
      if(element.label=="Boletas")
        this._boletas=true;
      if(element.label=="Vacaciones")
        this._vacacion=true;
        if(element.label=="Remuneraciones")
        this._remuneracion=true;
        if(element.label=="Aportes")
        this._aportes=true;
        if(element.label=="Planilla Sueldos")
        this._salarios=true;
        if(element.label=="Pedidos")
        this._pedidos=true;
        if(element.label=="Almacenes")
        this._almacenes=true;
        if(element.label=="Datos Usuario")
        this._datosuser=true;
        if(element.label=="C.A.S. y aportes")
        this._cas=true;
        if(element.label=="Planilla Refrigerios")
        this._refrigerio=true;
        if(element.label=="Reporte Almacen")
        this._repalmacen=true;
      //this.cadenaacceso=this.cadenaacceso+element.rol;
      //console.log('dentro');
    });

    // this.permiso=this.vpermisos();
    // console.log(this.permiso);

    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) { return false; }
            items.children.filter(subItems => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) { return false; }
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
            });
          });
        }
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


  // For Horizontal Menu
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }

  vpermisos(acceso:string) {
    var res:boolean=false;
    // console.log(Object.keys(this.perfil.permisos[0]).length);
    // console.log('ingreso al validador');
    // console.log(acceso);
    if(Object.entries(this.perfil.permisos).length!=0){
      if(acceso=='resumen')
        res=true;
    }
    if(acceso=='kardex'||acceso=='hojavida'||acceso=='dethojavida'||acceso=='decjurada'){
      res=true;
    }
    if(acceso=='listhojavida'&&(this._kardex||this._admin)){
      res=true;
    }
    if(acceso=='infouser'&&(this._datosuser||this._admin||this._cas)){
      res=true;
    }
    //segundo modulo
    if((acceso=='personal'||acceso=='asignacionrrhh'||acceso=='escala'||acceso=='item'||acceso=='eventual'||acceso=='externo'||acceso=='permanente'||acceso=='reppersonal') && (this._personal||this._admin)){
      res=true;
    }
    //tercer modulo
    if((Object.entries(this.perfil.permisos).length!=0)&&(acceso=='boletas'||acceso=='formsolicitud'||acceso=='c_permiso'||acceso=='c_formvac'||acceso=='c_marcacion')){
      res=true;
    }
     
    if(acceso=='c_detpermiso' && (this._admin)){
      res=true;
    }
    if(acceso=='c_detvacacion' && (this._vacacion||this._admin)){
      res=true;
    }

    //cuarto modulo
    if((this._refrigerio||this._salarios||this._admin)&&(acceso=='p_planilla'||acceso=='planilla')){
      res=true;
    }
    if(acceso=='p_refrigerios' && (this._refrigerio||this._admin)){
      res=true;
    }
    if(acceso=='p_sueldos' && (this._salarios||this._admin)){
      res=true;
    }

     //quinto modulo
    //  if((Object.entries(this.perfil.permisos).length!=0)&&(acceso=='almacen'||acceso=='a_config'||acceso=='a_solicitud')){
    //   res=true;
    // }
    if((this._almacenes||this._pedidos||this._admin||this._repalmacen)&&(acceso=='almacen'||acceso=='a_config'||acceso=='a_solicitud')){
      res=true;
    }
    if(acceso=='a_partidas' && this._admin){
      res=true;
    }
    if((acceso=='a_ingresos'||acceso=='a_saldos'||acceso=='a_proveedor'||acceso=='a_material') && (this._almacenes||this._admin)){
      res=true;
    }
    if(acceso=='a_reportes' && (this._repalmacen||this._admin)){
      res=true;
    }
    
    return res;
  }
  

}